export default __webpack_public_path__ + "static/Facebook-883ea1f0b633b0fba09da82475a6de34.png";